import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import CheckFairness from '@/components/Fairplay/CheckFairness';
import SeoHead from '@/components/SEO/SeoHead';

export type TTab = 'jackpot' | 'coinflip' | 'casebattles';

interface Params {
    game: TTab | undefined;
    hash: string | undefined;
    secret: string | undefined;
    battleId: string | undefined;
    block: string | undefined;
    blockId: string | undefined;
}

const Fairplay = () => {
    const router = useRouter();
    const { game, hash, secret, battleId, block, blockId }: Params =
        router.query as unknown as Params;

    const [tab, setTab] = useState<TTab>();

    useEffect(() => {
        setTab(game || 'jackpot');
    }, [game]);

    return (
        <>
            <SeoHead category="Fairplay" path="/fairplay" />
            <CheckFairness
                setTab={setTab}
                tab={tab}
                initialHash={hash}
                initialSecret={secret}
                initialBattleId={battleId}
                initialBlock={block}
                initialBlockId={blockId}
                game={game as TTab}
            />
        </>
    );
};

export default Fairplay;
